<template>
    <auth-layout :isPlain="true" :progress="isSent ? 100 : 0" :isProgressBarHidden="true">
        <template v-if="isSent">
            <common-content-wrapper width="large">
                <common-page-header :heading="$t('pages.auth.forgot_password.heading.done')"></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-message type="success">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p v-html="$t('pages.auth.forgot_password.sent_instructions', { email })"></p>
                </common-message>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-page-copy size="minor">
                    <p>{{ $t('pages.auth.forgot_password.check_spam') }}</p>
                </common-page-copy>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-button
                    :label="$t('pages.auth.forgot_password.back_to_login')"
                    :route="{ name: 'auth.login' }"
                    type="primary"
                    size="large"
                ></common-button>
            </common-content-wrapper>
        </template>

        <template v-else>
            <common-content-wrapper width="large">
                <common-page-header
                    :heading="$t('pages.auth.forgot_password.heading.initial')"
                    :content="$t('pages.auth.forgot_password.description')"
                ></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <forgot-password-form @sent="afterSent($event)"></forgot-password-form>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-page-copy size="minor">
                    <router-link :to="{ name: 'auth.login' }">
                        {{ $t('pages.auth.forgot_password.back_to_login') }}
                    </router-link>
                </common-page-copy>
            </common-content-wrapper>
        </template>
    </auth-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import ForgotPasswordForm from 'components/forms/AuthForgotPasswordForm'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            AuthLayout,
            ForgotPasswordForm,
        },

        data() {
            return {
                email: null,
                isSent: false,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.forgot_password.title')
            },
        },

        methods: {
            afterSent({ email }) {
                this.email = email
                this.isSent = true
            },
        },

        mounted: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = 'mobile'
        },
        beforeDestroy: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = ''
        },
    }
</script>
